module.exports = __webpack_public_path__ + "img/6a30b10.png";